<template>
  <div class="stacked-wrapper">
    <div class="contentSection text-center">
      <p>
        Many employers have begun reviewing credit history when making hiring decisions. Not having an accurate and updated credit report
        may be putting your potential job at risk. Checking your credit can identify negative issues right away.
        <br><br>
        All applicants can receive their FREE credit score and $1 credit report from our Recommended Credit Score provider.
       </p>
      <h2 class="urgent"><i style="color:#6fc420" class="fas fa-arrow-down"></i> Click on the YES button below.</h2>
      <div class="row mt-4">
        <div class="col-md-6 text-right">
          <input
            style
            class="greenBtn hidden"
            v-model="offer.linkOutButtonText"
            type="text"
            required
          >
        </div>
        <div class="col-md-6 text-left">
          <input style class="greyBtn hidden" v-model="offer.nextButtonText" type="text" required>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: {
    offer: { type: Object, required: true }
  }
}
</script>
<style lang="scss" scoped>
</style>
